import { render, staticRenderFns } from "./ModalConsignmentRemove.vue?vue&type=template&id=2c919886&"
import script from "./ModalConsignmentRemove.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports